const VIPSonkosPage = () => import('./index.vue')
const VIPSonkosFilter = () => import('./_pages/sonkos_filter.vue')
const VIPSonkosManualSubscriptionIndex = () => import('./_pages/subscription.vue')
import { EditorGuard, ManagerGuard } from '@/common/guard'

export default [
  {
    path: '/vip_sonkos',
    beforeEnter: EditorGuard,
    component: VIPSonkosPage,
    name: 'VIPSonkosIndex'
  },
  {
    path: '/vip_sonkos/select/:filter',
    component: VIPSonkosFilter,
    name: 'VIPSonkosFilter'
  },
  {
    path: '/vip_sonkos/subscriptions',
    beforeEnter: EditorGuard,
    component: VIPSonkosFilter,
    name: 'VIPSonkosSubscriptionsFilter'
  },
  {
    path: '/vip_sonkos/packages/manual/subscribe/:userId/:id/:option',
    beforeEnter: ManagerGuard,
    component: VIPSonkosManualSubscriptionIndex,
    name: 'VIPSonkosManualSubscriptionIndexRoute'
  }
]
